import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import useFetch from "../hooks/fetch.hook";
import { updateUser } from "../helper/helper";
import { useNavigate, Link } from "react-router-dom";
import { useAuthStore } from "../store/store";  // <-- Import Zustand hook

export default function Profile() {
  const [{ isLoading, apiData, serverError }] = useFetch();
  const navigate = useNavigate();
  const setEmail = useAuthStore(state => state.setEmail); // Get setter from Zustand

  const [firstName, setFirstName] = useState("");
  const [email, setEmailLocal] = useState("");
  const [originalData, setOriginalData] = useState({ firstName: "", email: "" });
  const [isDirty, setIsDirty] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (apiData) {
      setFirstName(apiData.firstName || "");
      setEmailLocal(apiData.email || "");
      setOriginalData({
        firstName: apiData.firstName || "",
        email: apiData.email || "",
      });
      setIsDirty(false);
    }
  }, [apiData]);

  useEffect(() => {
    setIsDirty(firstName !== originalData.firstName || email !== originalData.email);
  }, [firstName, email, originalData]);

  async function handleSave() {
    setSaving(true);
    try {
      await updateUser({ firstName, email });
      toast.success("Profile updated!");
      setOriginalData({ firstName, email });
      setIsDirty(false);
    } catch {
      toast.error("Failed to update profile.");
    } finally {
      setSaving(false);
    }
  }

  function handleResetPassword() {
    setEmail(email);  // <-- Save current email to Zustand store
    navigate("/recovery");
  }

  if (isLoading)
    return (
      <h1 className="text-2xl font-bold text-center mt-20">Loading...</h1>
    );
  if (serverError)
    return (
      <h1 className="text-xl text-red-500 text-center mt-20">
        {serverError.message}
      </h1>
    );

  return (
    <div className="flex flex-col bg-white min-h-screen">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="flex flex-grow items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white shadow-lg rounded-lg p-6">
          <h1 className="text-2xl font-bold text-center mb-6">Profile</h1>

          <div className="w-full">
            <input
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full p-3 border rounded-lg mb-4"
              type="text"
              placeholder="First Name"
            />

            <input
              value={email}
              onChange={(e) => setEmailLocal(e.target.value)}
              className="w-full p-3 border rounded-lg mb-4"
              type="email"
              placeholder="Email"
            />

            {isDirty && (
              <button
                onClick={handleSave}
                disabled={saving}
                className="w-full bg-black text-white p-3 rounded-lg hover:bg-gray-800 mb-4"
              >
                {saving ? "Saving..." : "Save Changes"}
              </button>
            )}

            <button
              onClick={handleResetPassword}
              className="w-full bg-[#e53935] text-white p-3 rounded-lg hover:bg-black hover:text-white mb-2"
            >
              Reset Password
            </button>

            <p className="text-center text-sm text-black">
              <strong>Logout?</strong>{" "}
              <Link to="/" className="text-[#e53935] hover:underline">
                Click here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}